<template>
  <div>
    <div v-if="!loader">
      <div v-if="paymentMethods.length > 0" class="mt-4">
        <small>Elige un método de pago</small>
        <b-form-radio-group v-model="$parent.PayMethodSelected" class="mt-lg-2">
          <b-card class="text-dark mt-2" v-for="(method, index) in paymentMethods" :key="method.id">
            <b-row>
              <b-col cols="1">
                <b-form-radio :value="index+1" inline></b-form-radio>
              </b-col>
              <b-col cols="1" class="text-left">
                <i
                  v-if="method.type == 'VISA'"
                  style="font-size:30px;color:#004B89"
                  class="fab fa-cc-visa"
                ></i>
                <i
                  v-else-if="method.type == 'MASTERCARD'"
                  style="font-size:30px;color:#e5021a;"
                  class="fab fa-cc-mastercard"
                ></i>
                <i
                  v-else-if="method.type == 'AMEX'"
                  style="font-size:30px;color:#016cc9"
                  class="fab fa-cc-amex"
                ></i>
              </b-col>
              <b-col class="text-left">
                <h4>
                  <strong>**** {{method.last4}}</strong>
                </h4>
              </b-col>
            </b-row>
          </b-card>
          
          <!-- <b-card class="text-dark mt-2">
            <b-row>
              <b-col cols="1">
                <b-form-radio value="0" inline></b-form-radio>
              </b-col>
              <b-col class="text-left">OXXO</b-col>
            </b-row>
          </b-card> -->
          <b-card class="text-dark mt-2">
            <b-row>
              <b-col cols="1">
                <b-form-radio value="0" inline></b-form-radio>
              </b-col>
              <b-col class="text-left">Nuevo método de pago</b-col>
            </b-row>
          </b-card>
        </b-form-radio-group>
        <hr/>
      </div>
    </div>
    <div v-else class="p-4">
      <center>
        <b-spinner variant="dark" style="width: 2rem; height: 2rem;" small class="m-1"></b-spinner>
      </center>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        loader: true,
        paymentMethods: []
      };
    },
    created() {
      this.getMethods();
    },
    methods: {
      getMethods() {
        this.api
          .get("payment/methods")
          .then(({data}) => {
            this.loader = false;
            this.paymentMethods = data;
            if (this.paymentMethods.length <= 0) {
              this.$parent.PayMethodSelected = 0;
            }
          })
          .catch(err => {
            this.loader = false;
            this.$parent.PayMethodSelected = 0;
            console.log(err);
          });
      }
    },
    watch: {
      "$parent.PayMethodSelected": function (val) {
        if (val != 0) {
          this.$parent.Method = this.paymentMethods[val - 1];
        } else {
          this.$parent.Method = false;
        }
      }
    }
  };
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/#public/payments/PayMethods.vue